<template>
  <div class="mobflex-window">
    <div class="ma-2 cus-brows-tabs newdesignteamnfl-page">
      <div class="tab1">
        <v-card class="mt-6">
          <v-tabs
              v-model="tab"
              background-color="#72C604"
              dark
              centered
              class="mb-2 tab-row"
              show-arrows
              slider-size="5"
          >
            <v-tabs-slider color="#17408B"></v-tabs-slider>

            <!-- //? NBA.. -->
            <template v-if="defaultSport == '1'">
              <!-- tab-5 -->
              <v-tab exact :to="{ name: 'NbaNews' }"> News </v-tab>

              <!-- tab-1 -->
              <v-tab exact :to="{ name: 'NbaDailyLineups' }">
                Gameday Lineups
              </v-tab>

              <!-- tab-2 -->
              <v-tab exact :to="{ name: 'NbaBrowseTeam' }">
                Browse Teams
              </v-tab>

              <!-- tab-3 -->
              <v-tab exact :to="{ name: 'NbaTopPlayers' }"> Top Players </v-tab>

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'NbaPlayerTrends' }">
                Player Trends
              </v-tab>
            </template>

            <!-- //?Mlb.. -->
            <template v-if="defaultSport == '2'">
              <!-- tab-6 -->
              <v-tab exact :to="{ name: 'MlbNews' }"> News </v-tab>

              <!-- tab-1 -->
              <v-tab exact :to="{ name: 'MlbDailyLineups' }">
                Gameday Lineups
              </v-tab>

              <!-- tab-2 -->
              <v-tab exact :to="{ name: 'MlbAdp' }"> ADP </v-tab>

              <!-- tab-3 -->
              <v-tab exact :to="{ name: 'MlbBrowseTeam' }">
                Browse Teams
              </v-tab>

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'MlbTopPlayers' }"> Top Players </v-tab>

              <!-- tab-5 -->
              <v-tab exact :to="{ name: 'MlbPlayerTrends' }">
                Player Trends
              </v-tab>
            </template>

            <!-- //? Nhl.. -->
            <template v-if="defaultSport == '3'">
              <!-- tab-6 -->
              <v-tab exact :to="{ name: 'NhlNews' }"> News </v-tab>

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'NhlStartGoalies' }">
                Starting Goalies
              </v-tab>

              <!-- tab-1 -->
              <v-tab exact :to="{ name: 'NhlBrowseTeam' }">
                Browse Teams
              </v-tab>

              <!-- tab-2 -->
              <v-tab exact :to="{ name: 'NhlTopPlayers' }"> Top Players </v-tab>

              <!-- tab-3 -->
              <v-tab exact :to="{ name: 'NhlLineComb' }">
                Line Combination
              </v-tab>

              <!-- tab-5 -->
              <v-tab exact :to="{ name: 'NhlPlayerTrends' }">
                Player Trends
              </v-tab>
            </template>

            <!-- //? Nfl.. -->
            <template v-if="defaultSport == '4'">
              <!-- tab-3 -->
              <v-tab exact :to="{ name: 'NflBrowseTeam' }"> Gameday </v-tab>

              <!-- tab 7 -->
              <v-tab exact :to="{ name: 'NflNews' }"> News </v-tab>

              <!-- tab -->
              <v-tab exact :to="{ name: 'NflRankings' }"> Rankings </v-tab>

              <!-- tab-1 -->
              <v-tab exact :to="{ name: 'NflAdp' }"> ADP </v-tab>

              <!-- tab-4 -->
              <v-tab exact :to="{ name: 'NflTopPlayers' }"> Top Players </v-tab>

              <!-- tab-5 -->
              <v-tab exact :to="{ name: 'NflPlayerTrends' }">
                Player Trends
              </v-tab>

              <!-- tab 6 -->
              <v-tab exact :to="{ name: 'NflTeamDepth' }"> Depth Chart </v-tab>

              <!-- tab 7 -->
              <v-tab exact :to="{ name: 'NflBlog' }"> Blog </v-tab>
            </template>
          </v-tabs>

          <v-tabs-items v-model="tab">
            <transition
              mode="out-in"
              enter-active-class="animate__animated animate__fadeInLeft animate__faster"
              leave-active-class="animate__animated animate__fadeOutRight animate__faster"
            >
              <router-view
                :allSlate="this.allSlate"
                :defaultSport="defaultSport"
                :defaultOptimizer="defaultOptimizer"
              ></router-view>
            </transition>
          </v-tabs-items>
        </v-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "InsightTab",
  props: ["allSlate", "defaultSport", "defaultOptimizer"],
  data() {
    return {
      tab: null,
      role: localStorage.getItem("role"),
    };
  },
};
</script>
<style scoped>
@media (max-width: 415px) {
  .tab-row {
    display: flex !important;
    overflow-x: scroll !important;
    white-space: nowrap !important;
  }
}
</style>
